// src/components/ImageTile.js
import React, { useState, useRef } from "react";
import Modal from "../modal";
import Button from "../button";

const ImageTilePicker = ({
  name,
  onChange,
  className,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  maxSize,
  minSize,
  text = "Select Image",
}) => {
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const inputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if the file size is less than 2MB
      if (maxSize && file.size >= maxSize * 1024 * 1024) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "Image Error",
          message: `The file size should not exceed ${maxSize}MB.`,
          open: true,
          actions: (
            <div className="w-full">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
        e.target.value = null;
        return;
      }

      // Check if the file type is an image
      if (!file.type.startsWith("image/")) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "Image Error",
          message: "File must be an image.",
          open: true,
          actions: (
            <div className="w-full">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
        e.target.value = null;
        return;
      }

      // Create a new Image object
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        // Check if the image dimensions are less than or equal to 1920 x 1920
        if (
          (maxHeight && maxWidth && img.width > maxWidth) ||
          img.height > maxHeight
        ) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: "Image Error",
            message: `Image dimensions must be max of ${maxWidth} x ${maxHeight}`,
            open: true,
            actions: (
              <div className="w-full">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
          URL.revokeObjectURL(objectUrl);
          e.target.value = null;
          return;
        }

        // Use URL.createObjectURL to display the selected image
        setSelectedImage(objectUrl);
        console.log(e);
        onChange(e);
      };

      img.src = objectUrl;
    }
  };

  const removeImage = (event) => {
    setSelectedImage(null);
    onChange(event);
  };

  return (
    <div className={`border p-4 mx-auto w-full ${className}`}>
      {selectedImage ? (
        <div>
          <img src={selectedImage} alt="Selected" className="mb-4 w-full" />
          <button
            name={name}
            onClick={removeImage}
            className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600 w-full"
          >
            Remove
          </button>
        </div>
      ) : (
        <div>
          <button
            className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 w-full"
            onClick={() => inputRef.current.click()}
          >
            {text}
          </button>
          <input
            type="file"
            accept="image/*"
            ref={inputRef}
            className="hidden"
            name={name}
            onChange={handleImageChange}
          />
        </div>
      )}
      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </div>
  );
};

export default ImageTilePicker;
